import React, { FunctionComponent, useCallback, useMemo } from 'react';

import { PropertySelectField } from '@paragon/client-tools';
import { ComponentDesignSummary } from '@paragon/contract-library';

const LOADING = ['Loading...'];

interface Props {
  loading: boolean;
  summaries: ComponentDesignSummary[];
  value: string;
  onChange(value: string): void;
}

export const TemplateComponentSelectField: FunctionComponent<Props> = (props) => {
  const propertyName = 'Component To Copy';
  const componentDesignGuids = useMemo(() => props.summaries.map((summary) => summary.guid), [props.summaries]);
  const getComponentName = useCallback(
    (guid: string) => props.summaries.find((summary) => summary.guid === guid)?.component.name ?? 'Unknown Component',
    [props.summaries],
  );

  if (props.loading) {
    return <PropertySelectField disabled property={propertyName} value={LOADING[0]} options={LOADING} />;
  }

  return (
    <PropertySelectField
      property={propertyName}
      value={props.value}
      options={componentDesignGuids}
      getName={getComponentName}
      submit={props.onChange}
    />
  );
};
